import * as $ from 'jquery';
// show button when user agree
$("#ckDeleteProgram").on("change", function () {
    const checked = $(this).is(':checked');
    $("#btnDeleteProgram").prop('disabled', !checked);
});
export default undefined;
